export default __webpack_public_path__ + "static/media/sr_mty.c810239f.jpg";